var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cargo-department-new-select",
    _vm._g(
      _vm._b(
        { attrs: { "default-value": _vm.value }, on: { change: _vm.onChange } },
        "cargo-department-new-select",
        _vm.$attrs,
        false
      ),
      _vm.new$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }